export default {
    teams() {
        return axios.get('/api/member/teams');
    },
    games(data) {
        return axios.post('/api/member/teams/games', data);
    },
    saveTeam(data) {
        return axios.post('/api/member/teams/save', data);
    },
    sendRemovePlayer(data) {
        return axios.post('/api/member/teams/removeteamplayer', data);
    },
    sendRemovePosition(data) {
        return axios.post('/api/member/teams/removeteamposition', data);
    },
    sendNewPlayers(data) {
        return axios.post('/api/member/teams/addteamplayers', data);
    },
    sendNewTempPlayers(data) {
        return axios.post('/api/member/teams/addteamtempplayers', data);
    },
    sendGameForfeit(data) {
        return axios.post('/api/member/teams/gameforfeit', data);
    }
};
